function ListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fillRule="evenodd"
        d="M12.5 28.75a1.25 1.25 0 011.25-1.25h22.5a1.25 1.25 0 010 2.5h-22.5a1.25 1.25 0 01-1.25-1.25zm0-10a1.25 1.25 0 011.25-1.25h22.5a1.25 1.25 0 010 2.5h-22.5a1.25 1.25 0 01-1.25-1.25zm0-10a1.25 1.25 0 011.25-1.25h22.5a1.25 1.25 0 010 2.5h-22.5a1.25 1.25 0 01-1.25-1.25zM9.635 5.363a1.25 1.25 0 010 1.77l-3.75 3.75a1.25 1.25 0 01-1.77 0l-1.25-1.25a1.252 1.252 0 011.77-1.77L5 8.232l2.865-2.868a1.25 1.25 0 011.77 0zm0 10a1.25 1.25 0 010 1.77l-3.75 3.75a1.25 1.25 0 01-1.77 0l-1.25-1.25a1.252 1.252 0 011.77-1.77l.365.368 2.865-2.868a1.25 1.25 0 011.77 0zm0 10a1.25 1.25 0 010 1.77l-3.75 3.75a1.25 1.25 0 01-1.77 0l-1.25-1.25a1.252 1.252 0 011.77-1.77l.365.368 2.865-2.868a1.25 1.25 0 011.77 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ListIcon;
